<template>
  <div>
    <div id="content">
      <div class="inner_static">
        <div id="register">
          <h1 class="tit1">メンバー登録</h1>
          <div v-if="this.errorMessage.text" class="error_text">{{this.errorMessage.text}}</div>
          <div v-if="this.validateErrorMessages">
            <div v-for="(msg,index) in validateErrorMessages" :key="index"><label class="error_text">{{msg}}</label></div>
          </div>
          <ul class="lst_register">
            <li>
              <div class="item">
                <label for="name">【ニックネーム】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <input  v-model="userForm.nickName" type="text" id="name" name="name" class="int">
                <div v-if="this.errors['nickName']" class="error_text">{{this.errors['nickName']}}</div>
              </div>
            </li>
            <li>
              <div class="item">
                <label for="bir_yy">【生年月日】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <div class="ins_wrap">
                  <div class="bir">
                    <select id="bir_yy" name="bir_yy" class="sel" v-model="userForm.year">
                      <option value=""></option>
                      <option v-for="(y,index) in currentYear - yearOffset" :key="index" v-bind:value="y + yearOffset">{{y + yearOffset}}</option>
                    </select>
                    <span class="unit">年</span>
                  </div>
                  <div class="bir">
                    <select id="bir_mm" name="bir_mm" class="sel" v-model="userForm.month">
                      <option value=""></option>
                      <option v-for="(m,index) in 12" :key="index" v-bind:value="m">{{m}}</option>
                    </select>
                    <span class="unit">月</span>
                  </div>
                  <div class="bir">
                    <select id="bir_dd" name="bir_dd" class="sel" v-model="userForm.day">
                      <option value=""></option>
                      <option v-for="(d,index) in 31" :key="index" v-bind:value="d">{{d}}</option>
                    </select>
                    <span class="unit">日</span>
                  </div>
                </div>
                <div v-if="this.errors['year']" class="error_text">{{this.errors['year']}}</div>
                <div v-if="this.errors['month']" class="error_text">{{this.errors['month']}}</div>
                <div v-if="this.errors['day']" class="error_text">{{this.errors['day']}}</div>
                <p class="att">※設定していただくとパスワードをお忘れの際、パスワードの設定がスムーズにおこなえます。</p>
              </div>
            </li>
            <li>
              <div class="item">
                <label for="email">【メールアドレス】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <div class="ins_wrap">
                  <input v-model="userForm.email" type="text" id="email" name="email" class="int">
                </div>
                <div v-if="this.errors['email']" class="error_text">{{this.errors['email']}}</div>
                <div class="check_wrap">
                  <span class="ins_check_box">
                    <input v-model="userForm.promotion" type="checkbox" id="check_receive" class="chk"><label for="check_receive" class="lbl_chk">キャンペーンなどのおトクな情報を受け取る</label>
                  </span>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <label for="password">【パスワード】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <div class="ins_wrap">
                  <input v-model="userForm.password" type="text" id="password" name="password" class="int">
                </div>
                <div v-if="this.errors['password']" class="error_text">{{this.errors['password']}}</div>
                <p class="att">※英数字8〜12文字でご入力ください。</p>
              </div>
            </li>
            <li>
              <div class="item">
                【性別】<strong class="req">※必須</strong>
              </div>
              <div class="cnt">
                <input v-model="userForm.gender" type="radio" id="gender_M" name="gender" value="0" checked class="rad"><label for="gender_M" class="lbl_rad">男性</label>
                <input v-model="userForm.gender" type="radio" id="gender_F" name="gender" value="1" class="rad"><label for="gender_F" class="lbl_rad">女性</label>
                <div v-if="this.errors['gender']" class="error_text">{{this.errors['gender']}}</div>
              </div>
            </li>
            <li>
              <div class="item">
                <label for="job">【職業】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <select v-model="userForm.job" id="job" name="job" class="sel">
                  <option v-for="(job,index) in jobList" :key="index" :value="index">{{job}}</option>
                </select>
                <div v-if="this.errors['job']" class="error_text">{{this.errors['job']}}</div>
              </div>
            </li>
            <li>
              <div class="item">
                <label for="code">【紹介コード】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <input v-model="userForm.referralCode" type="text" id="code" name="code" class="int">
                <div v-if="this.errors['referralCode']" class="error_text">{{this.errors['referralCode']}}</div>
              </div>
            </li>
          </ul>
          <div class="check_wrap chk_agreement">
            <span class="ins_check_box">
              <input v-model="agreement" type="checkbox" id="check_agreement" class="chk"><label for="check_agreement" class="lbl_chk"></label>
              <div class="lbl_chk_div">
                <span class="btn_terms" @click="btnTermsClick()">利用規約</span>、<span class="btn_privacy" @click="btnPrivacyClick()">プライバシーポリシー</span>に同意する
              </div>
            </span>
          </div>
          <div class="btn_area">
            <a class="btn1" @click="btnRegistClick()">登録する</a>
          </div>
          <p class="att_reg">
            ※ 携帯メールアドレスをご登録いただく場合、<strong class="url">domans.jp</strong>からのドメイン着信許可を設定してください。
          </p>
        </div>
      </div>
    </div>
    <kg-terms />
    <kg-privacypolicy />
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
// import {KG_URL, KG_STORAGE_KEY} from '../../../constants/App'
import {KG_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import LoadingModal from '../../../components/common/LoadingModal'
import * as Check from '../../../utils/Check'

// kaggul Module
import Terms from '../common/Terms'
import PrivacyPolicy from '../common/PrivacyPolicy'

export default {
  components: {
    'kg-terms': Terms,
    'kg-privacypolicy': PrivacyPolicy,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      userForm: {
        nickName: '',
        year: '',
        month: '',
        day: '',
        email: '',
        password: '',
        gender: 0,
        job: '',
        referralCode: '',
        promotion: false
      },
      agreement: false,
      jobList: [ '会社員' ],
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    btnRegistClick: function () {
      if (!this.agreement) {
        App.showModal({
          title: '',
          messages: [' 利用規約、プライバシーポリシーに同意してください。']
        })
        return
      }
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      this.errors = {}
      this.validate()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        App.showModal({
          title: '',
          messages: [' 入力内容を確認してください。']
        })
        return
      }
      let payload = {
        nickName: this.userForm.nickName,
        year: this.userForm.year,
        month: this.zeroPadding(String(this.userForm.month), 2),
        day: this.zeroPadding(String(this.userForm.day), 2),
        email: this.userForm.email,
        password: this.userForm.password,
        gender: this.userForm.gender,
        job: this.userForm.job,
        referralCode: this.userForm.referralCode,
        promotion: this.userForm.promotion
      }
      axios.post(KG_URL.USER + '/new/regist-user-account', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
            // App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
            this.$router.push('/kagull/user/registcomplete')
          }
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    btnTermsClick: function (event) {
      // 利用規約クリック時の処理
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var terms = document.getElementById('terms')
      var bodyElements = document.getElementsByTagName('body')
      if (terms.classList.contains('open')) {
        terms.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        terms.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    btnPrivacyClick: function (event) {
      // プライバシーポリシークリック時の処理
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var terms = document.getElementById('privacy')
      var bodyElements = document.getElementsByTagName('body')
      if (terms.classList.contains('open')) {
        terms.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        terms.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    validate: function () {
      // 入力チェック
      if (!this.userForm.nickName || !this.userForm.nickName.trim()) {
        this.errors['nickName'] = 'ニックネームが未入力です。'
      }
      if (!this.userForm.year) {
        this.errors['year'] = '年が未入力です。'
      }
      if (!this.userForm.month) {
        this.errors['month'] = '月が未入力です。'
      }
      if (!this.userForm.day) {
        this.errors['day'] = '日が未入力です。'
      }
      if (!Check.isMail(this.userForm.email)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
      if (!Check.isPassword(this.userForm.password)) {
        this.errors['password'] = 'パスワード' + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
      }
      if (this.userForm.gender == null) {
        this.errors['gender'] = '性別が未入力です。'
      }
      if (this.userForm.job == null) {
        this.errors['job'] = '職業が未入力です。'
      }
      if (!this.userForm.referralCode || !this.userForm.referralCode.trim()) {
        this.errors['referralCode'] = '紹介コードが未入力です。'
      }
    },
    zeroPadding: function (str, length) {
      if (!(typeof (str) === 'string' || str instanceof String)) {
        return str
      }
      if (!str) return ''
      let diff = length - str.length
      for (let i = 0; i < diff; i++) {
        str = '0' + str
      }
      return str
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    }
  },
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    },
    yearOffset: function () {
      // 年選択プルダウンのオフセット
      return 1899
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/user/RegistUserForm.vue